export default __webpack_public_path__ + "static/media/ask.e59428ad.svg";